export const BUSINESS = 'business';
export const INDIVIDUAL = 'individual';
